import { render, staticRenderFns } from "./TableDraggable.vue?vue&type=template&id=1fc1fae2&scoped=true&"
import script from "./TableDraggable.vue?vue&type=script&lang=js&"
export * from "./TableDraggable.vue?vue&type=script&lang=js&"
import style0 from "./TableDraggable.vue?vue&type=style&index=0&id=1fc1fae2&prod&lang=scss&"
import style1 from "./TableDraggable.vue?vue&type=style&index=1&id=1fc1fae2&prod&scoped=true&lang=css&"
import style2 from "./TableDraggable.vue?vue&type=style&index=2&id=1fc1fae2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fc1fae2",
  null
  
)

export default component.exports